import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import RangesByPoolTable from "./RangesByPoolTable";
import { useParams } from "react-router-dom";
import { fetchWithToken } from "../../../../apiUtils";

const useStyles = makeStyles({
  table: {
    marginTop: 45,
  },
  loading: {
    marginTop: "25%",
    marginLeft: "50%",
  },
});

const RangesByPool = ({ isAdmin }) => {
  const classes = useStyles();

  const { poolId } = useParams();

  const [dataObj, setDataObj] = useState({
    ranges: [],
    loading: true,
  });

  useEffect(() => {
    fetchWithToken(`api/Ranges/ByPool/${poolId}`)
      .then((res) => res.json())
      .then((data) =>
        setDataObj({
          ranges: data,
          loading: false,
        })
      );
  }, []);

  return (
    <>
      {dataObj.loading ? (
        <CircularProgress className={classes.loading} />
      ) : (
        <div className={classes.table}>
          <RangesByPoolTable ranges={dataObj.ranges} isAdmin />
        </div>
      )}
    </>
  );
};

export default RangesByPool;
